<template>
    <div class="footer">
        <div class="footer-content">
            <p>
                <a href="http://beian.miit.gov.cn/" target="_blank">{{contents[1]}}</a>
                |
                <a href="wenwangwenfuben.jpg" target="_blank">{{contents[2]}}</a>
                <br>
                <a href="http://sq.ccm.gov.cn/ccnt/sczr/service/business/emark/toDetail/81bfb8c7d6c443f79ff894ce75c4539a" target="_blank"><img src="../assets/img/wenhuajingying.png" alt="" width="50" height="50"></a>
            </p>
            <p>{{contents[3]}}</p>
            <p>{{contents[4]}}</p>
            <ul style="overflow: unset!important;">
                <li>
                    <router-link style="width: 100%" :to="'/article/6'">{{contents[5]}}</router-link>
                </li>
                <li>
                    <router-link style="width: 100%" :to="'/article/7'">{{contents[6]}}</router-link>
                </li>
                <li>
                    <router-link style="width: 100%" :to="'/article/8'">{{contents[7]}}</router-link>
                </li>
                <li>
                    <router-link style="width: 100%" :to="'/article/9'">{{contents[8]}}</router-link>
                </li>
                <li>
                  <a href="http://www.ntfusion.com/privacy-policy.html" target="_blank" style="margin-left: 5px;">privacypolicy</a>
                </li>
            </ul>
            <p>{{contents[9]}}</p>
        </div>
    </div>
</template>

<script>
    import httpRequest from '../service/http_request';
    const icp = require('../lib/icp');

    export default {
        name: 'router2',
        data () {
            return {
                contents: ''
            }
        },
        created(){
            this.getContent();
        },
        methods: {
            getContent() {
                var self = this;
                httpRequest.request(
                    'post',
                    icp.urls.page_getContents, {
                        params:{
                            page: 1
                        }
                    }, function (res) {
                        self.contents = res;
                    })
            }
        }
    }
</script>
<style lang="less">
    .footer {
        width: auto;
        padding: 40px 0;
        font-size: 13px;
        color: #ffffff;
        background-color: #434447;
        .footer-content {
            margin: auto;
            text-align: center;
            position: relative;
            ul {
                display: inline-block;
                li {
                    display: inline-block;
                    width: 60px;
                    height: 15px;
                    line-height: 15px;
                    a {
                        color: #ffffff;
                    }
                }
                li + li {
                    border-left: 2px solid #ffffff;
                }
            }
            p {
                margin: 10px 0 20px;

                a {
                    color: #ffffff;
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue